import type { ComponentType } from 'react';

import { PriceDrop, Clearance, IconProps, RedemptionOffer } from 'assets/icons';

type BadgeVariant = 'priceDrop' | 'clearance' | 'redemption';

interface BadgeVariantConfig {
  Icon: ComponentType<IconProps>;
  text: string;
  bg: string;
}

export const BadgeVariants: Record<BadgeVariant, BadgeVariantConfig> = {
  priceDrop: { Icon: PriceDrop, text: 'PRICE DROP', bg: 'bg-cef-red' },
  clearance: { Icon: Clearance, text: 'GREAT PRICE', bg: 'bg-cef-red' },
  redemption: {
    Icon: RedemptionOffer,
    text: 'REDEMPTION OFFER',
    bg: 'bg-cef-red',
  },
};

interface BadgeProps {
  variant: BadgeVariant;
}

const Badge = ({ variant }: BadgeProps) => {
  const config = BadgeVariants[variant];

  const { Icon, text, bg } = config || BadgeVariants.clearance; // default to clearance as its more generic

  return (
    <div
      data-testid="product-badge"
      className={`product-badge fl ai-c g-4 fl-shrink-0 ${bg}`}>
      <Icon />
      <span className="fw-600 tc-white ff-heading ws-nw">{text}</span>
    </div>
  );
};

export default Badge;
